import React, { useCallback } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import Spinner from '@tls/ui-spinner';

import Input from '../../../shared/forms/inputFormik/inputFormik.component';
import Dropzone from '../../../shared/forms/dropzone/dropzone.container';
import ButtonsGroup from '../../../shared/forms/buttonsGroup/buttonsGroup.component';
import Loading from '../../../shared/displayComponents/loading.component';
import formStyles from '../../../shared/forms/forms.module.scss';

import styles from './pdfAttachment.module.scss';

const DOCUMENT_ACCEPTED_TYPES = { 'application/pdf': ['.pdf'] };

const PdfAttachmentForm = ({
  onCancel: handleCancel = () => null,
  selectedPdfFile = null,
  onPdfFileSelected = () => null,
  onPdfFileDialogOpen = () => null,
  onPdfFileDialogCancel = () => null,
  existingPdfFileName = null,
  isSaveDisabled = false,
  isPdfFileProcessing = false,
}) => {
  const { isSubmitting, values, submitForm } = useFormikContext();

  const handleDrop = useCallback(
    file => {
      if (file) {
        onPdfFileSelected(file);
      }
    },
    [onPdfFileSelected],
  );

  return (
    <form>
      <Loading isLoading={isSubmitting}>
        <div className="row">
          <Field
            className={`col form-text ${formStyles.fieldWithInlineLabel}`}
            label="Form Name"
            name="formName"
            component={Input}
            autoComplete="off"
          />
          <Field
            className={`col form-text ${formStyles.fieldWithInlineLabel}`}
            label="SWP Form Id"
            name="swpFormId"
            component={Input}
            autoComplete="off"
          />
        </div>
        <div className="row">
          <Field
            className={`col form-text ${formStyles.fieldWithInlineLabel}`}
            label="Form Description"
            name="formDescription"
            component={Input}
            autoComplete="off"
          />
        </div>
        <div className={formStyles.dropdownWithInlineLabel}>
          <label className="a-form-label">PDF</label>
          <Dropzone
            onDropCallback={handleDrop}
            onFileDialogOpen={onPdfFileDialogOpen}
            onFileDialogCancel={onPdfFileDialogCancel}
            value={selectedPdfFile}
            acceptTypes={DOCUMENT_ACCEPTED_TYPES}
            existingFileName={existingPdfFileName ?? values.pdfLibPdf}
            disabled={isPdfFileProcessing}
          />
          {isPdfFileProcessing && (
            <div className={styles.fileProcessingHint}>
              <Spinner small />
              <span>Processing...</span>
            </div>
          )}
        </div>
        <ButtonsGroup
          className={styles.buttonsRow}
          fullWidth={false}
          submitButtonLabel="Save"
          isSubmitting={isSubmitting}
          disabledSubmit={isSaveDisabled}
          onCancelClick={handleCancel}
          submitForm={submitForm}
        />
      </Loading>
    </form>
  );
};

PdfAttachmentForm.propTypes = {
  onCancel: PropTypes.func,
  selectedPdfFile: PropTypes.instanceOf(File),
  onPdfFileSelected: PropTypes.func,
  onPdfFileDialogOpen: PropTypes.func,
  onPdfFileDialogCancel: PropTypes.func,
  existingPdfFileName: PropTypes.string,
  isSaveDisabled: PropTypes.bool,
  isPdfFileProcessing: PropTypes.bool,
};

export default PdfAttachmentForm;
